import Vue from 'vue'
import VueI18n from 'vue-i18n'
import axios from 'axios'

// 引入自定义英文包
import customEN from '../lang/locale/en-US'


Vue.use(VueI18n)
// 准备翻译的语言环境信息
const messages = {
    "en-US": customEN, // 将自定义英文包加入
    // zh: require('./locale/zh-CN.js') // 将自定义英文包加入
}
export const i18n = new VueI18n({
  locale: 'en-US', // 设置语言环境
  fallbackLocale: 'en-US',
  messages // 设置语言环境信息
})

const loadedLanguages = ['en-US'] // 我们的预装默认语言

function setI18nLanguage (lang) {
  i18n.locale = lang
  axios.defaults.headers.common['Accept-Language'] = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

export function loadLanguageAsync(lang) {
  // 如果语言相同
  if (i18n.locale === lang) {
    return Promise.resolve(setI18nLanguage(lang))
  }

  // 如果语言已经加载
  if (loadedLanguages.includes(lang)) {
    return Promise.resolve(setI18nLanguage(lang))
  }

  // 如果尚未加载语言
  return import(/* webpackChunkName: "lang-[request]" */ `../lang/locale/${lang}.js`).then(
    messages => {
      i18n.setLocaleMessage(lang, messages.default)
      loadedLanguages.push(lang)
      return setI18nLanguage(lang)
    }
  )
}


// WEBPACK FOOTER //
// ./src/setup/i18n-setup.js